﻿'use strict'

var Typo = {
    getDBUtcDataTime: function () {
        var now = new Date();

        var month = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
        var day = (now.getDate()) < 10 ? '0' + (now.getDate()) : (now.getDate());
        var hours = (now.getHours()) < 10 ? '0' + (now.getHours()) : (now.getHours());
        var minutes = (now.getMinutes()) < 10 ? '0' + (now.getMinutes()) : (now.getMinutes());
        var seconds = (now.getSeconds()) < 10 ? '0' + (now.getSeconds()) : (now.getSeconds());

        var utcDateTime = now.getFullYear().toString() + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + 'Z';

        return utcDateTime;
    },
    //getDBUtcDataTimeWithParam: function (localLastDate) {
    //    var now = new Date(localLastDate);

    //    var month = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
    //    var day = (now.getDate()) < 10 ? '0' + (now.getDate()) : (now.getDate());
    //    var hours = (now.getHours()) < 10 ? '0' + (now.getHours()) : (now.getHours());
    //    var minutes = (now.getMinutes()) < 10 ? '0' + (now.getMinutes()) : (now.getMinutes());
    //    var seconds = (now.getSeconds()) < 10 ? '0' + (now.getSeconds()) : (now.getSeconds());

    //    var utcDateTime = now.getFullYear().toString() + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + 'Z';

    //    return utcDateTime;
    //},
    getDBUtcDataTimeWithParam: function (localLastDate) {
        var now = new Date(localLastDate);

        var month = (now.getUTCMonth() + 1) < 10 ? '0' + (now.getUTCMonth() + 1) : (now.getUTCMonth() + 1);
        var day = (now.getUTCDate()) < 10 ? '0' + (now.getUTCDate()) : (now.getUTCDate());
        var hours = (now.getUTCHours()) < 10 ? '0' + (now.getUTCHours()) : (now.getUTCHours());
        var minutes = (now.getUTCMinutes()) < 10 ? '0' + (now.getUTCMinutes()) : (now.getUTCMinutes());
        var seconds = (now.getUTCSeconds()) < 10 ? '0' + (now.getUTCSeconds()) : (now.getUTCSeconds());

        var utcDateTime = now.getUTCFullYear().toString() + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + 'Z';

        return utcDateTime;
    },
    getDBUtcDataTime_StartEvent: function () {
        var now = new Date();

        var month = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
        var day = (now.getDate()) < 10 ? '0' + (now.getDate()) : (now.getDate());
        var hours = '00';
        var minutes = '00';
        var seconds = '01';

        var utcDateTime = now.getFullYear().toString() + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + 'Z';

        return utcDateTime;
    },
    getDBUtcDataTime_EndEvent: function () {
        var now = new Date();
        now.setDate(now.getDate() + 7)

        var month = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
        var day = (now.getDate()) < 10 ? '0' + (now.getDate()) : (now.getDate());
        var hours = '00';
        var minutes = '00';
        var seconds = '01';

        var utcDateTime = now.getFullYear().toString() + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + 'Z';

        return utcDateTime;
    },
    getUTCUnicDataTimrId: function () {
        var now = new Date();

        var month = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
        var day = (now.getDate()) < 10 ? '0' + (now.getDate()) : (now.getDate());
        var hours = (now.getHours()) < 10 ? '0' + (now.getHours()) : (now.getHours());
        var minutes = (now.getMinutes()) < 10 ? '0' + (now.getMinutes()) : (now.getMinutes());
        var seconds = (now.getSeconds()) < 10 ? '0' + (now.getSeconds()) : (now.getSeconds());

        var utcDateTime = now.getFullYear().toString() + month + day + hours + minutes + seconds;

        return utcDateTime;
    },

}

export default Typo;